<template>
    <div id="Mars">
        <div class="cloud" v-show="cloudShow">
            <img :src="require(`../assets/img/cloud${cloud}.png`)" alt="">
        </div>
        <div class="info-box" v-show="!result">
            <div class="img-box" v-for="(img, index) of dataInfo[area]" :key="index">
                <img :src="img" alt="">
                <div class="info-btn" v-show="index === dataInfo[area].length - 1">
                    <img @click="createResult" src="../assets/img/create.png" alt="">
                    <img @click="$router.go(-1)" src="../assets/img/back.png" alt="">
                </div>
            </div>
        </div>
        <div class="result" v-show="result">
            <img class="result-bg" :src="result" alt="">
            <!--<img class="result-bg" src="../assets/img/jinan/jinan1.jpg" alt="">-->
            <img class="tips-img" v-show="pre" @click="pre = false" src="../assets/img/tips.png" alt="">
            <div class="tips animated infinite swing">长按保存海报</div>
            <div class="tip-fen" style="bottom: 9vh" @click="openTips">点击分享</div>
            <div class="tip-fen" @click="openTips">传递火炬</div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "Mars",
        data() {
            return {
                cloud: 1,
                cloudShow: true,
                pre: false,
                dataInfo: {
                    '济南': [
                        require('../assets/img/jinan/jinan1.jpg'),
                        require('../assets/img/jinan/jinan2.jpg'),
                        require('../assets/img/jinan/jinan3.jpg'),
                        require('../assets/img/jinan/jinan4.jpg'),
                        require('../assets/img/jinan/jinan5.jpg')
                    ],
                    '青岛': [
                        require('../assets/img/qingdao/qingdao1.jpg'),
                        require('../assets/img/qingdao/qingdao2.jpg'),
                        require('../assets/img/qingdao/qingdao3.jpg'),
                        require('../assets/img/qingdao/qingdao4.jpg'),
                    ],
                    '淄博': [
                        require('../assets/img/zibo/zibo1.jpg'),
                        require('../assets/img/zibo/zibo2.jpg'),
                        require('../assets/img/zibo/zibo3.jpg')
                    ],
                    '枣庄': [
                        require('../assets/img/zaozhuang/zaozhuang1.jpg'),
                        require('../assets/img/zaozhuang/zaozhuang2.jpg'),
                        require('../assets/img/zaozhuang/zaozhuang3.jpg')
                    ],
                    '东营': [
                        require('../assets/img/dongying/dongying1.jpg'),
                        require('../assets/img/dongying/dongying2.jpg'),
                        require('../assets/img/dongying/dongying3.jpg'),
                        require('../assets/img/dongying/dongying4.jpg')
                    ],
                    '烟台': [
                        require('../assets/img/yantai/yantai1.jpg'),
                        require('../assets/img/yantai/yantai2.jpg'),
                        require('../assets/img/yantai/yantai3.jpg')
                    ],
                    '潍坊': [
                        require('../assets/img/weifang/weifang1.jpg'),
                        require('../assets/img/weifang/weifang2.jpg'),
                        require('../assets/img/weifang/weifang3.jpg')
                    ],
                    '济宁': [
                        require('../assets/img/jining/jining1.jpg'),
                        require('../assets/img/jining/jining2.jpg'),
                        require('../assets/img/jining/jining3.jpg'),
                        require('../assets/img/jining/jining4.jpg'),
                        require('../assets/img/jining/jining5.jpg')
                    ],
                    '泰安': [
                        require('../assets/img/taian/taian1.jpg'),
                        require('../assets/img/taian/taian2.jpg'),
                        require('../assets/img/taian/taian3.jpg'),
                        require('../assets/img/taian/taian4.jpg'),
                        require('../assets/img/taian/taian5.jpg')
                    ],
                    '威海': [
                        require('../assets/img/weihai/weihai1.jpg'),
                        require('../assets/img/weihai/weihai2.jpg'),
                        require('../assets/img/weihai/weihai3.jpg')
                    ],
                    '日照': [
                        require('../assets/img/rizhao/rizhao1.jpg'),
                        require('../assets/img/rizhao/rizhao2.jpg'),
                        require('../assets/img/rizhao/rizhao3.jpg'),
                        require('../assets/img/rizhao/rizhao4.jpg'),
                        require('../assets/img/rizhao/rizhao5.jpg')
                    ],
                    '临沂': [
                        require('../assets/img/linyi/linyi1.jpg'),
                        require('../assets/img/linyi/linyi2.jpg'),
                        require('../assets/img/linyi/linyi3.jpg'),
                        require('../assets/img/linyi/linyi4.jpg'),
                        require('../assets/img/linyi/linyi5.jpg')
                    ],
                    '德州': [
                        require('../assets/img/dezhou/dezhou1.jpg'),
                        require('../assets/img/dezhou/dezhou2.jpg'),
                        require('../assets/img/dezhou/dezhou3.jpg')
                    ],
                    '聊城': [
                        require('../assets/img/liaocheng/liaocheng1.jpg'),
                        require('../assets/img/liaocheng/liaocheng2.jpg'),
                        require('../assets/img/liaocheng/liaocheng3.jpg')
                    ],
                    '滨州': [
                        require('../assets/img/binzhou/binzhou1.jpg'),
                        require('../assets/img/binzhou/binzhou2.jpg'),
                        require('../assets/img/binzhou/binzhou3.jpg')
                    ],
                    '菏泽': [
                        require('../assets/img/heze/heze1.jpg'),
                        require('../assets/img/heze/heze2.jpg'),
                        require('../assets/img/heze/heze3.jpg'),
                        require('../assets/img/heze/heze4.jpg')
                    ]
                },
                area: '',
                openid: '',
                result: '',
            }
        },
        methods: {
            initCloud() {
                let timer = setInterval(() => {
                    if (this.cloud < 30) {
                        this.cloud++
                    } else {
                        this.cloudShow = false
                        clearTimeout(timer)
                    }
                }, 100)
            },
            getParams() {
                this.area = this.$route.query.area
                this.openid = this.$route.query.openid
            },
            async createResult() {
                console.log(111)
                let res = await axios.get('http://zhuanti.e23.cn/index.php?m=content&c=huoju&a=show_poster', {
                    params: {
                        city: this.area,
                        openid: this.openid
                    }
                })
                if (res.data.code === 200) {
                    this.result = res.data.url
                }
            },
            openTips() {
                this.pre = true
                document.body.scrollTop=document.documentElement.scrollTop=0
            }
        },
        created() {
            this.getParams()
        },
        mounted() {
            this.initCloud()
        }
    }
</script>

<style scoped lang="less">
    @import "~animate.css";

    #Mars {
        width: 100%;
        height: 100%;
        background: rgb(12,99,162);

        .cloud {
            position: fixed;
            left: 0;
            top: 0;
            z-index: 200;
            height: 100%;
            width: 100%;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .info-box {
            position: absolute;
            left: 0;
            top: 0;
            z-index: 199;
            display: flex;
            flex-direction: column;

            .img-box {
                width: 100%;
                position: relative;

                > img {
                    vertical-align: bottom;
                    display: inline-block;
                    width: 100%;
                }

                .info-btn {
                    width: 100%;
                    position: absolute;
                    bottom: 4vw;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;

                    > img {
                        &:nth-of-type(1) {
                            width: 45vw;
                        }

                        &:nth-of-type(2) {
                            width: 30vw;
                        }
                    }
                }
            }
        }

        .result {
            width: 100%;
            position: relative;

            .result-bg {
                width: 100%;
                vertical-align: bottom;
            }

            .tips {
                position: absolute;
                left: 50%;
                bottom: 44vw;
                color: white;
                font-size: 18px;
                transform: translateX(-50%);
                border: 1px rgb(11,99,162) solid;
                border-radius: 2vw;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 1vw 2vw;
                background: rgb(11,99,162);
            }

            .tip-fen {
                position: absolute;
                /*transform: translateX(-50%);*/
                /*left: 4vw;*/
                /*bottom: 6vw;*/
                bottom: 5.5vh;
                left: 6vw;
                color: white;
                /*font-size: 18px;*/
                /*width: 12vw;*/
                /*height: 4vw;*/
                /*padding: 2vw 1vw;*/
                /*border: 1px white solid;*/
                /*border-radius: 2vw;*/
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: bold;
                font-size: 16px;
            }

            .tips-img {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
            }
        }
    }


</style>
